import { useMemo } from "react";
import useValidator from "../atoms/usePosOrderValidatorAtom";

const LOYALTY_POINTS = 8;
const EXTRA_COST = 11;

const useCartValidatorValuesHook = () => {
  const [validator] = useValidator();

  const filteredDiscounts = useMemo(
    () =>
      validator?.discounts
        ?.filter((i) => i.type !== LOYALTY_POINTS)
        ?.filter((i) => i.type !== EXTRA_COST),
    [validator?.discounts]
  );

  const extras = useMemo(
    () => validator?.discounts?.filter((i) => i.type === EXTRA_COST),
    [validator?.discounts]
  );

  const totalExtras = useMemo(
    () => extras?.reduce((p, cur) => p + cur.single_price_inc_vat, 0),
    [extras]
  );

  const uniqueExtraName = useMemo(() => {
    const uniqueExtraSet = new Set(extras?.map((i) => i.name));
    return Array.from(uniqueExtraSet || []);
  }, [extras]);

  const totalDiscount = useMemo(
    () =>
      filteredDiscounts?.reduce(
        (p, cur) => p + (cur.single_price_inc_vat ?? 0),
        0
      ),
    [filteredDiscounts]
  );

  const uniqueDiscountName = useMemo(() => {
    const uniqueDiscountSet = new Set(filteredDiscounts?.map((i) => i.name));
    return Array.from(uniqueDiscountSet || []);
  }, [filteredDiscounts]);

  return {
    totalDiscount,
    uniqueDiscountName,
    totalExtras,
    uniqueExtraName,
  };
};

export default useCartValidatorValuesHook;
